import React, { Fragment } from 'react';
import {
  Accordion,
  Button,
  Divider,
  Form,
  Grid,
  Icon,
} from 'semantic-ui-react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';

import { DatePickerCustomButton } from 'Components';
import { FilterEnum } from 'Common/FieldEnum';
import {
  InputField,
  SelectField,
  DatePickerField,
} from 'Common/SemanticWrapper';
import { GenericFiltersContainer } from 'Components/filters/container';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { CreateEditTransferEnum } from 'Common/FieldEnum';
import { NewEditTransferEnum } from 'Common/Constants/Enumeration/ManageTransferEnum';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';
import { GridEnum } from 'Common/Constants/Enumeration/GridEnum';
import { SiteComponent } from 'Common/SiteComponent';
import { ItemGridFormField } from 'Components';

const CustomInputComponent = props => {
  const { isDisabled, IsNewEdit } = props;
  if (IsNewEdit !== NewEditTransferEnum.NEW) {
    return (
      <Grid.Column>
        <Field
          name={CreateEditTransferEnum.TransferID}
          component={InputField}
          type={'text'}
          label={'Transfer #'}
          disabled={isDisabled}
        />
      </Grid.Column>
    );
  }
  return null;
};

const CustomFilterComponent = props => {
  const { handleChange, fields, filterValues, clearFilters } = props;
  return (
    <Grid className={'remove-spacing'}>
      <GenericFiltersContainer
        fields={fields}
        onChange={handleChange}
        filterValues={filterValues}
      />
      <Grid.Row width={2}>
        <Grid.Column width={10} />
        <Grid.Column width={6}>
          <Button
            className={'clear-filters-button'}
            content="Clear Filters"
            onClick={clearFilters}
            type={'button'}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

const CreateEditTransferComponent = props => {
  const {
    assignItemsBidGroupData,
    assignItemsItemGroupData,
    handleChange,
    clearFilters,
    isDisabled,
    filterValues,
    onChangeOfFromSite,
    onChangeOfToSite,
    transferItemsData,
    fetchingTransferItems,
    IsNewEdit,
    resetPageOnDataChange,
    onResetPageOnDataChange,
    onChangeOfDate,
    activeIndexForFilter,
    handleClick,
    fromSite,
    fromSiteName,
    toSiteName,
    toSites,
  } = props;

  const fields = [
    {
      name: FilterEnum.GroupId_Item,
      component: SelectField,
      type: 'text',
      options: assignItemsItemGroupData,
      label: 'ITEM GROUP',
    },
    {
      name: FilterEnum.GroupId_Bid,
      component: SelectField,
      type: 'text',
      options: assignItemsBidGroupData,
      label: 'BID GROUP',
      maxLength: 20,
    },
  ];
  return (
    <Fragment>
      <Form>
        <Grid>
          <Grid.Row columns={4}>
            <CustomInputComponent
              isDisabled={isDisabled}
              IsNewEdit={IsNewEdit}
            />
            <Grid.Column>
              <Field
                component={DatePickerField}
                label={'Transfer Date'}
                dateFormat={DATE_FORMAT_FOR_UI}
                name={CreateEditTransferEnum.TransferDT}
                type={'text'}
                dropdownMode="select"
                customInput={<DatePickerCustomButton isDisabled={isDisabled} />}
                onChange={onChangeOfDate}
              />
            </Grid.Column>
            <Grid.Column>
              {isDisabled ? (
                <Field
                  name={CreateEditTransferEnum.FromSiteName}
                  component={InputField}
                  type="text"
                  maxLength={50}
                  label={'From Site'}
                  value={fromSiteName}
                  disabled={isDisabled}
                />
              ) : (
                <SiteComponent
                  name={CreateEditTransferEnum.FromSite}
                  {...this.props}
                  isForm={true}
                  label={'From Site'}
                  isAllRequired={false}
                  showAllActiveSites={true}
                  disabled={isDisabled}
                  onChange={onChangeOfFromSite}
                />
              )}
            </Grid.Column>
            <Grid.Column>
              {isDisabled ? (
                <Field
                  name={CreateEditTransferEnum.ToSiteName}
                  component={InputField}
                  type="text"
                  maxLength={50}
                  label={'To Site'}
                  value={toSiteName}
                  disabled={isDisabled}
                />
              ) : (
                <Field
                  name={CreateEditTransferEnum.ToSite}
                  label={'To Site'}
                  disabled={isDisabled}
                  onChange={onChangeOfToSite}
                  options={toSites}
                  component={SelectField}
                />
              )}
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={8}>
              <Field
                name={CreateEditTransferEnum.Comments}
                component={InputField}
                type="text"
                maxLength={50}
                label={'Comments'}
                disabled={isDisabled}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <Accordion fluid styled>
          <Accordion.Title
            active={!activeIndexForFilter}
            index={0}
            onClick={handleClick}
          >
            <Icon name="dropdown" />
            <span className="text-orange">Filter By</span>
          </Accordion.Title>
          <Accordion.Content active={!activeIndexForFilter}>
            <CustomFilterComponent
              isDisabled={isDisabled}
              IsNewEdit={IsNewEdit}
              handleChange={handleChange}
              fields={fields}
              filterValues={filterValues}
              clearFilters={clearFilters}
            />
          </Accordion.Content>
        </Accordion>
        <Divider horizontal />
        <Grid>
          <Grid.Row>
            <Grid.Column width={4}>
              {fromSite === '0' ? null : (
                <label className={'text-orange'}>
                  Available Items at Site {fromSite}
                </label>
              )}
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Field
                component={ItemGridFormField}
                name={CreateEditTransferEnum.TransferItemsInfo}
                {...{
                  dataSource: transferItemsData,
                  fetchingOrderItems: fetchingTransferItems,
                  gridName: GridEnum.INV_TransferOrder_CreateEdit_View,
                  tableName: TableNamesEnum.TRANSFER_ITEM_TABLE,
                  onResetPageOnDataChange: onResetPageOnDataChange,
                  resetPageOnDataChange: resetPageOnDataChange,
                  showCalc: true,
                }}
                disabled={isDisabled}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    </Fragment>
  );
};

CreateEditTransferComponent.propTypes = {
  assignItemsBidGroupData: PropTypes.array.isRequired,
  assignItemsItemGroupData: PropTypes.array.isRequired,
  transferItemsData: PropTypes.array,
  handleChange: PropTypes.func,
  clearFilters: PropTypes.func,
  onChangeOfFromSite: PropTypes.func,
  onChangeOfToSite: PropTypes.func,
  fetchingTransferItems: PropTypes.bool,
  onResetPageOnDataChange: PropTypes.func,
  onChangeOfDate: PropTypes.func,
  handleClick: PropTypes.func,
  filterValues: PropTypes.object.isRequired,
  IsNewEdit: PropTypes.string,
  activeIndexForFilter: PropTypes.number,
  fromSite: PropTypes.string,
  fromSiteName: PropTypes.string,
  toSiteName: PropTypes.string,
  isDisabled: PropTypes.bool,
  resetPageOnDataChange: PropTypes.bool,
};

CreateEditTransferComponent.defaultProps = {
  transferItemsData: [],
  handleChange: () => {},
  clearFilters: () => {},
  onChangeOfFromSite: () => {},
  onChangeOfToSite: () => {},
  fetchTransferItems: false,
  onResetPageOnDataChange: () => {},
  onChangeOfDate: () => {},
  handleClick: () => {},
  isDisabled: false,
  resetPageOnDataChange: true,
  IsNewEdit: '0',
  activeIndexForFilter: 0,
  fromSite: '0',
  fromSiteName: '',
  toSiteName: '',
};
export default CreateEditTransferComponent;



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/transfer/components/createEditTransfer/CreateEditTransfer.js